import { render, staticRenderFns } from "./InfoRequest.vue?vue&type=template&id=90189708"
import script from "./InfoRequest.vue?vue&type=script&lang=js"
export * from "./InfoRequest.vue?vue&type=script&lang=js"
import style0 from "./InfoRequest.vue?vue&type=style&index=0&id=90189708&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports